/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Nav_Resources_RoadmapInputs */

const en_better_studio_nav_resources_roadmap = /** @type {(inputs: Better_Studio_Nav_Resources_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roadmap`)
};

/**
* | output |
* | --- |
* | "Roadmap" |
*
* @param {Better_Studio_Nav_Resources_RoadmapInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_nav_resources_roadmap = /** @type {((inputs?: Better_Studio_Nav_Resources_RoadmapInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Nav_Resources_RoadmapInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_nav_resources_roadmap(inputs)
});